"use client"

import { createContext, useContext, useState, type ReactNode } from "react"
import axios from "axios"

interface User {  
  Id: number
  Login: string
  Name: string
  Email: string
  Store: string
  StatusId: number
  IsBlocked: boolean
  Otp: string
  Role: "admin" | "user"
}

interface AuthContextType {
  isAuthenticated: boolean
  user: User | null
  sendOtp: (email: string) => Promise<boolean>
  verifyOtpAndLogin: (enteredOtp: string) => boolean
  logout: () => void
}

const AuthContext = createContext<AuthContextType | undefined>(undefined)

export function AuthProvider({ children }: { children: ReactNode }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [user, setUser] = useState<User | null>(null)

  const sendOtp = async (email: string): Promise<boolean> => {
    try {

      debugger;
      // const response = await axios.post("https://qaacsstoreapi.acsouth.com:443/api/send-otp", {
      //   user_email: email,
      // })
      // const response = await axios.post("https://devprodapi.acsouth.com/api/send-otp", {
      //   user_email: email,
      // })
      //PRODUCTION
        const response = await axios.post("https://acsstoreapi.acsouth.com:443/api/send-otp", {
        user_email: email,
      
       //DR ACtivity
        // const response = await axios.post("https://dracsstoreapi.acsouth.com:443/api/send-otp", {
        // user_email: email,
      })
      const data = response.data
debugger;
      if (data.Email && data.Store) {
        const role = data.StatusId === 1 ? "user" : "admin"

        setUser({
            Id: data.Id,
            Login: data.Login,
            Name: data.Name,
            Email: data.Email,
            Store: data.Store,
            StatusId: data.StatusId,
            IsBlocked: data.IsBlocked,
            Otp: data.Otp,
            Role: role,
          })

        return true
      } else {
        return false
      }
    } catch (error) {
      console.error("OTP send failed:", error)
      return false
    }
  }

  const verifyOtpAndLogin = (enteredOtp: string): boolean => {
    if (user && user.Otp === enteredOtp) {
      setIsAuthenticated(true)
      return true
    } else {
      return false
    }
  }

  const logout = () => {
    setUser(null)
    setIsAuthenticated(false)
  }

  return (
    <AuthContext.Provider value={{ isAuthenticated, user, sendOtp, verifyOtpAndLogin, logout }}>
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth() {
  const context = useContext(AuthContext)
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider")
  }
  return context
}
